<template>
  <form id="frm_action">
    <div class="p-formgrid">
      <Toolbar class="fixed-bottom-toolbar div-button css-button-top-right">
        <template slot="right">
          <Button label="Back" @click="backToList()" id="back" class="main-style-button" />
        </template>
      </Toolbar>
      <!-- <div class="col-6">
        <div class="p-card-field">
          <label class="p-col-fixed txt-right txt-required">Category name</label>
          <div class="p-col">
            <InputText id="name" type="text" class="" v-model="obj_data.name" placeholder="Input" />
          </div>
        </div>
      </div> -->



      <div v-for="(item, index) in listLang" :key="item.id">

        <!-- Field for Service Name and Description -->
        <div class="col-6" v-if="item.iso_code === 'dk'">
          <div class="p-card-field">
            <label class="p-col-fixed txt-right txt-required">Category name ({{ item.iso_code.toUpperCase() }})</label>
            <div class="p-col">
              <InputText maxlength="100" :id="'name_' + item.iso_code" type="text" v-model="item.service_name"
                placeholder="Input" />
            </div>
          </div>
        </div>


        <!-- Checkbox to enable English fields -->
        <div class="col-6" v-if="item.iso_code === 'dk' && index === 0">
          <div class="p-card-field div_check">
            <div class="p-col checkbox">
              <Checkbox v-model="obj_data.is_use_en" :binary="true" />
              <label class="p-col-fixed txt-right text">Use English</label>
            </div>
          </div>
        </div>

        <!-- English Section -->
        <div class="col-6" v-if="item.iso_code === 'en'">
          <div class="p-card-field">
            <label class="p-col-fixed txt-right txt-required">Category name ({{ item.iso_code.toUpperCase() }})</label>
            <div class="p-col">
              <InputText :disabled="!obj_data.is_use_en" maxlength="100" :id="'name_' + item.iso_code" type="text"
                v-model="item.service_name" placeholder="Input" />
            </div>
          </div>
        </div>


      </div>



      <div class="col-6">
        <div class="p-card-field">
          <label class="p-col-fixed txt-right">Order</label>
          <div class="p-col">
            <InputNumber v-model="obj_data.ordinal">
            </InputNumber>
          </div>
        </div>
        <div class="p-card-field div_check">
          <div class="p-col checkbox">
            <Checkbox v-model="obj_data.active" :binary="true" />
            <label class="p-col-fixed txt-right text">Active</label>
          </div>
        </div>

      </div>
      <Toolbar class="fixed-bottom-toolbar div-button">
        <template slot="right">
          <Button :label="$constants.TEXT_BUTTON.BACK" @click="backToList()" class="p-button-outlined" id="back" />
          <Button v-if="mode == 'edit'" :label="$constants.TEXT_BUTTON.EDIT" @click="saveData()"
            class="main-style-button" />
          <Button v-else :label="$constants.TEXT_BUTTON.ADD" @click="saveData()" class="main-style-button" />
        </template>
      </Toolbar>
    </div>
  </form>
</template>
<script>
import DataServices from '@/core/DataServices';
import moment from "moment-timezone";

export default {
  components: {
  },
  props: {
    mode: String,
    model: Object,
    users: Array
  },
  data() {
    return {
      obj_data: {

      },
      dataBookingRound: [],
      selProperty: null,
      listProperty: [],
      listPropertyAll: [],
      from_to: null,
      address: null,
      start_booking_date: null,
      end_booking_date: null,
      partArr: [],
      time_zone_local: moment.tz.guess(true),
      componentKey: 0,
      listLang : [],
    }
  },
  watch: {
   
  },
  async mounted() {
    var dataLang = await this.$CoreService.getListLang({});
    var list_lang = dataLang.list;
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      this.obj_data = this.model;




        
      var lang_ser_arr = this.model?.lang_arr ?? [];
      var mapLS = {};
      for (let h = 0; h < lang_ser_arr.length; h++) {
        var itemLS = lang_ser_arr[h];
        mapLS[itemLS.id_lang] = itemLS;
      }

      for (let i = 0; i < list_lang.length; i++) {
        var itemL = list_lang[i];
        var id_l = itemL.id
        list_lang[i].content = (!this.$commonFuction.isEmpty(mapLS[id_l])) ? mapLS[id_l].description : '';
        list_lang[i].service_name = (!this.$commonFuction.isEmpty(mapLS[id_l])) ? mapLS[id_l].name : '';

      }
      this.listLang = list_lang
      console.log("GGGGGGGGGGGGGGGGGGGGGGGGGGGGGG", this.listLang);


      this.componentKey++;
    } else {





      for (let i = 0; i < list_lang.length; i++) {
        list_lang[i].content = '';
        list_lang[i].service_name = '';
      }
      this.listLang = list_lang




      //thêm mới
      this.obj_data = {
        active: true,
        ordinal: 1,
      };
      this.componentKey++;
    }
  },
  methods: {
    handleDataCkditor: function (e, index, key) {
      var dataContent = (e.length) ? e[0] : '';
      if (key == 'content') {
        //this.content = dataContent;
        this.listLang[index].content = dataContent;
      }
    }
    ,
    updateMatrix(data) {
      console.log(data);
      this.dataBookingRound = [...data];
      // this.componentKey++;
    },
    async toCalendar() {
      this.$router.push(`/admin/list-booking?view=calendar&propery_id=${this.selProperty?.id}`);
    },
    async getListProperty() {

      var where_key = {
        deleted: { _eq: false },
        // booking: {id: {_is_null: true} },
      }
      let { data } = await this.$apollo.query({
        query: DataServices.getList('property', { "fields": `id code name address booking{id} part {id part order_booking user {id fullname email}}` }),
        variables: {
          where_key: where_key,
          orderBy: [{ created_at: 'desc' }]
        },
        fetchPolicy: "network-only"
      })
      var list = data[Object.keys(data)];
      var list_property = [];
      // console.log("list===",list);
      for (let i = 0; i < list.length; i++) {
        const e = list[i];
        if (!e?.booking?.id || (this.selProperty?.id && this.selProperty?.id == e.id)) {
          list_property.push({ id: e.id, name: e.name, code: e.code, address: e.address, part: e.part });
        }
      }
      this.listProperty = list_property;
      this.listPropertyAll = list_property;
    },

    async SearchProperty(search, loading) {
      console.log(loading);
      if (search !== '' && search !== null) {
        var where_key = {
          deleted: { _eq: false },
          // booking: {id: {_is_null: true} },
          _or: {
            _iregex: this.$commonFuction.search(search),
          }
        };
        let { data } = await this.$apollo.query({
          query: DataServices.getList('property', { "fields": `id code name address booking {id} part {id part order_booking user {id fullname email}}` }),
          variables: {
            where_key: where_key,
            orderBy: [{ created_at: 'desc' }]
          },
          fetchPolicy: "network-only"
        })
        var list = data[Object.keys(data)];
        var list_property = [];
        // console.log("list===",list);
        for (let i = 0; i < list.length; i++) {
          const e = list[i];
          if (!e?.booking?.id || (this.selProperty?.id && this.selProperty?.id == e.id)) {
            list_property.push({ id: e.id, name: e.name, code: e.code, address: e.address, part: e.part });
          }
        }
        this.listProperty = list_property;
      } else {
        // cosnole.log("dasdasd")
        this.listProperty = this.listPropertyAll
      }
    },
    backToList() {
      this.$emit('back');
    },
    async validateData() {
      this.validationErrors = {};


      // let name_add = document.getElementById("name");
      // if (this.$commonFuction.isEmptyObject(this.obj_data.name)) {
      //   name_add.setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
      // } else {
      //   name_add.setCustomValidity("");
      // }



      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()) {
        console.log('test=====================');
        inpObj.reportValidity();
        return true;
      }
    },

    async saveData() {
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return
      }
      console.log("this.from_to", this.from_to);
      console.log("partArr", this.dataBookingRound);
      var params = {
        name: this.obj_data?.name ?? '',
        ordinal: this.obj_data?.ordinal ?? 1,
        active: this.obj_data?.active ?? true,
        is_use_en : this.obj_data?.is_use_en ?? false,
      }
      params["list_lang"] = this.listLang
      console.log('saveData', params)
      this.$emit('save', params)
    },
  },
}
</script>

<style lang="scss">
.p-formgrid {
   padding-top: 15px;
}
.main-style-button {
  background: #0086C4;
}
.p-multiselect {
  width: 450px;
}

.p-multiselect-label:not(.p-placeholder) {
  padding-top: .25rem;
  padding-bottom: .25rem;

}

.category-item-value {
  padding: .25rem .5rem;
  border-radius: 3px;
  display: inline-flex;
  margin-right: .2rem;
  background-color: var(--primary-color);
  color: var(--primary-color-text);
}

.p-multiselect-label-container {
  height: 40px;
}

.p-inputtext {
  margin: 0px 0px 0px 4px;
}

//style form add-edit
@media screen and (min-width: 1001px) {
  .input_distance {
    width: 728px !important;
  }
}

label.p-col-fixed txt-right {
  margin-bottom: 0px !important;
}

div.p-card-field {
  padding: 0px !important;
}

.p-col-fixed {
  padding: 0px !important;
  margin: 0px 0px 0px 9px !important;
}

.input_text {
  width: 760px !important;
  height: 48px !important;
}

//.txt-right {
//  font-weight: bold;
//}

.multiselect {
  width: 760px !important;
}

.layout-main {
  background: #00000029;
}

.vs__clear {
  display: none;
}

.input_width {
  width: 760px !important;
  height: 48px !important;
}

#distance {
  width: 1px !important;
  height: 48px !important;
  border-left: 0px;
  border-top: 0px;
  border: 1px solid #C8C8C8;
  border-radius: 0px;
  //border-top: none!important;
  //border: 1px solid rgba(60, 60, 60, 0.26);;
}

.manager-title {
  font-size: 24px !important;
}

.input-dif {
  margin-left: 5px !important;
  border-top: 0px;
}

.p-inputgroup-addon {
  height: 48px;
}

.txt-right {
  font-weight: bold;
}

.p-col-fixed {
  padding: 0px !important;
  //margin:0px 0px 0px 10px !important;
}

label.p-col-fixed txt-right {
  margin-bottom: 0px !important;
}

div.p-card-field {
  padding: 0px !important;
}

.margin {
  margin-bottom: 12px !important;
}

.border_color {
  border: 1px solid #C8C8C8;
}

.text {
  font-weight: normal !important;
  margin-left: 15px !important;
}

.div_check {
  margin-top: 12px !important;
}


//responsive
@media screen and (max-width: 600px) {
  .input_width {
    width: 100% !important;
  }

  .div-button {
    padding: 8px !important;
  }

  #distance {
    text-align: left !important;
    padding: 6.8px;
    width: 100% !important;
  }

  .p-inputgroup-addon {
    margin-right: 12px;
  }

}

@media screen and (max-width: 1000px) {
  .input_width {
    width: 100% !important;
  }

  .div-button {
    padding: 8px !important;
  }

  .p-inputgroup-addon {
    margin-right: 12px;
  }

  #distance {
    text-align: left !important;
    padding: 6.8px;
  }
}

.p-button-outlined {
  .p-button-label {
    color: #007ad9 !important;
  }
}
</style>
